export const remove = (element, attribute) => {
  if (element && element.hasAttribute(attribute)) {
    element.removeAttribute(attribute)
    // console.log(`DEBUG (MK / Dataset / remove): Removed attribute (${attribute}) from element.`, element)
  } else {
    console.log(`DEBUG (DOM.fns.dataset.remove): Attribute (${attribute}) not present on element.`, element)
  }
}
